import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import {
  fetchKeywordAnalysisPage,
  type KeywordAnalysisSort,
  type KeywordAnalysisView,
} from '@/api/keywordAnalysis/api'
import type { KeywordAnalysisPage } from '@/api/keywordAnalysis/types'

export function useKeywordAnalysis(
  page: number,
  pageSize: number,
  sort: KeywordAnalysisSort,
  view: KeywordAnalysisView,
): UseQueryResult<KeywordAnalysisPage> {
  return useQuery({
    queryKey: ['keyword-analysis', page, pageSize, sort, view],
    queryFn: ({ signal }) => fetchKeywordAnalysisPage(page, pageSize, sort, view, signal),
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  })
}
